import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoReminders = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--background-complete--inject-3",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M429,464.07c-62.14-1.54-125.17,7.1-186-5.75L241.7,460a211.87,211.87,0,0,0,103.66,28c20.49.12,40.87-2.75,61.15-5.61,17.88-2.52,35.93-5.08,52.8-11.49C450.54,465.06,439.47,464.33,429,464.07Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 232.44,
					y: 127.34,
					width: 54.7,
					height: 108.43,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 289.25,
					y: 127.34,
					width: 59.1,
					height: 108.43,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 289.25,
					y: 243.35,
					width: 59.1,
					height: 104.77,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "355.93 125.47 418.17 125.47 418.17 29.28 420.28 29.28 420.28 125.47 470.93 125.47 470.93 27.14 355.93 27.14 355.93 125.47",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 420.28,
					y: 127.34,
					width: 50.65,
					height: 108.43,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 420.28,
					y: 243.35,
					width: 50.65,
					height: 104.77,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 232.44,
					y: 243.35,
					width: 54.7,
					height: 104.77,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 355.93,
					y: 243.35,
					width: 62.24,
					height: 104.77,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 232.44,
					y: 349.99,
					width: 54.7,
					height: 94.41,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 420.28,
					y: 349.99,
					width: 50.65,
					height: 94.41,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "287.15 125.47 287.15 29.28 289.25 29.28 289.25 125.47 348.35 125.47 348.35 27.14 232.44 27.14 232.44 125.47 287.15 125.47",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 355.93,
					y: 349.99,
					width: 62.24,
					height: 94.41,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 289.25,
					y: 349.99,
					width: 59.1,
					height: 94.41,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 355.93,
					y: 127.34,
					width: 62.24,
					height: 108.43,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 51.49,
					y: 45.98,
					width: 141.86,
					height: 126.92,
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M193.35,172.9s0-.82,0-2.36,0-3.83,0-6.8c0-6-.05-14.67-.09-25.76,0-22.18-.09-53.87-.16-92l.32.32L51.5,46.36h0l.37-.38c0,46.17,0,89.62,0,126.92l-.33-.34,102.6.17,28.94.09,7.66,0,2,0c.44,0,.68,0,.68,0h-.64l-1.94,0-7.6,0-28.86.09-102.82.17h-.34v-.33c0-37.3,0-80.75,0-126.92V45.6h.39l141.85,0h.32V46c-.07,38.22-.13,70-.17,92.2,0,11.06-.06,19.75-.08,25.69,0,2.94,0,5.2,0,6.74S193.35,172.9,193.35,172.9Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M105.88,68.53c0,.21-7.47.38-16.68.38s-16.67-.17-16.67-.38,7.46-.38,16.67-.38S105.88,68.32,105.88,68.53Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M166,78.06c0,.21-20.51.38-45.81.38s-45.82-.17-45.82-.38,20.51-.38,45.82-.38S166,77.85,166,78.06Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.77,
					y: 94.2,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 87.48,
					y: 94.2,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 102.47,
					y: 93.93,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 116.91,
					y: 94.2,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.62,
					y: 94.2,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 146.33,
					y: 94.2,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.04,
					y: 94.2,
					width: 5.98,
					height: 5.98,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.77,
					y: 106.91,
					width: 5.98,
					height: 5.98,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 87.48,
					y: 106.91,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 102.19,
					y: 106.91,
					width: 5.98,
					height: 5.98,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 116.91,
					y: 106.91,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.62,
					y: 106.91,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 146.6,
					y: 106.63,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.04,
					y: 106.91,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.77,
					y: 119.61,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 87.75,
					y: 119.34,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 102.19,
					y: 119.61,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 116.91,
					y: 119.61,
					width: 5.98,
					height: 5.98,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.62,
					y: 119.61,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 146.33,
					y: 119.61,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.04,
					y: 119.61,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.77,
					y: 132.32,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 87.48,
					y: 132.32,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 102.19,
					y: 132.32,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 117.18,
					y: 132.05,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.62,
					y: 132.32,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 146.33,
					y: 132.32,
					width: 5.98,
					height: 5.98,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.04,
					y: 132.32,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.77,
					y: 145.02,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 87.48,
					y: 145.02,
					width: 5.98,
					height: 5.98,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 102.19,
					y: 145.02,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 116.91,
					y: 145.02,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.62,
					y: 145.02,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 146.6,
					y: 144.75,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.04,
					y: 145.02,
					width: 5.98,
					height: 5.98,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78.9,326a12.11,12.11,0,0,1-6.28-6.26c-.5-1.15-.51-2.94.72-3.2.76-.16,1.44.43,2,1l5.48,5.44a11.49,11.49,0,0,1,.38-8.91c.47-1,1.44-2,2.47-1.66.8.3,1.06,1.29,1.2,2.14l1.32,7.86a18.72,18.72,0,0,1,4.31-8.23c.76-.85,2-1.68,2.94-1.08s.81,1.77.63,2.76a39.17,39.17,0,0,1-2,7.2,13.54,13.54,0,0,1,8.52-3.38,3,3,0,0,1,2.52.81c.85,1.08.1,2.66-.8,3.69-2.69,3-9,3.82-13,3.55",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.15,332.46c-9.81-7.73-27.06-8.82-38.42-3.62-12.83,5.87-21.22,19.52-22.48,32.61-1.19,12.43,4.8,25,9.9,36.45l49.57.23c6-9.83,12.13-20.82,12.54-32.3S112.18,339.56,103.15,332.46Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80.92,325.64l-.22.06-.65.16-1,.23a7.88,7.88,0,0,0-1.42.37,27.91,27.91,0,0,0-8.4,4,37.83,37.83,0,0,0-9.56,9.93,57.14,57.14,0,0,0-4,7.14,62.35,62.35,0,0,0-3.08,8.24,37.79,37.79,0,0,0-.84,16.8A72.92,72.92,0,0,0,55.43,386c1.37,3.71,2.6,6.68,3.41,8.75.39,1,.7,1.8.92,2.38.1.25.17.46.23.63l.07.21s-.05-.06-.11-.2l-.27-.6c-.25-.57-.58-1.36-1-2.35-.86-2-2.13-5-3.55-8.71a71.05,71.05,0,0,1-3.85-13.41,37.8,37.8,0,0,1,.81-17,62.75,62.75,0,0,1,3.11-8.3,57.33,57.33,0,0,1,4.07-7.19,37.62,37.62,0,0,1,9.73-10,27.46,27.46,0,0,1,8.54-3.93A9.66,9.66,0,0,1,79,326l1.07-.19.65-.1Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M95.36,397.73a3.87,3.87,0,0,1,.23-.74l.74-2.09c.65-1.81,1.6-4.44,2.71-7.7s2.36-7.16,3.44-11.58A75.33,75.33,0,0,0,104.69,361a50.61,50.61,0,0,0-1.52-14.63,39.75,39.75,0,0,0-4.65-11.06A32.1,32.1,0,0,0,93.45,329c-.66-.7-1.27-1.14-1.63-1.49a4.41,4.41,0,0,1-.57-.54,5.46,5.46,0,0,1,.63.46c.38.33,1,.75,1.7,1.43a31.51,31.51,0,0,1,5.22,6.29,39.39,39.39,0,0,1,4.79,11.13,50.11,50.11,0,0,1,1.56,14.76,73.5,73.5,0,0,1-2.25,14.67c-1.11,4.43-2.4,8.34-3.55,11.59S97.2,393.17,96.5,395c-.35.87-.62,1.56-.82,2.07A5.52,5.52,0,0,1,95.36,397.73Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M85.78,325.93a4,4,0,0,1-.19.72l-.65,2.06c-.29.88-.63,2-1,3.25s-.84,2.71-1.27,4.32c-.93,3.21-1.9,7.06-2.88,11.36s-1.87,9.07-2.63,14.11-1.22,9.87-1.52,14.27c-.11,2.2-.26,4.29-.28,6.26,0,1,0,1.92-.06,2.83s0,1.79,0,2.62c0,1.67.07,3.18.11,4.5s.1,2.47.17,3.4.1,1.62.13,2.15a4.27,4.27,0,0,1,0,.75,5.42,5.42,0,0,1-.1-.74c-.06-.53-.13-1.25-.22-2.14s-.19-2.08-.25-3.4-.17-2.84-.18-4.51c0-.84,0-1.71,0-2.63s0-1.86,0-2.84c0-2,.14-4.07.24-6.28.28-4.41.75-9.26,1.49-14.31s1.7-9.82,2.67-14.13,2-8.16,3-11.36c.46-1.61.93-3.05,1.34-4.31s.76-2.35,1.08-3.23.55-1.52.73-2A4.88,4.88,0,0,1,85.78,325.93Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.83,365.4a15.41,15.41,0,0,1-3.39,1.8,16.11,16.11,0,0,1-3.58,1.38,15.71,15.71,0,0,1,3.39-1.8A16.31,16.31,0,0,1,43.83,365.4Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.4,351.16a19,19,0,0,1-3.72-1.88A18.28,18.28,0,0,1,38.2,347a19,19,0,0,1,3.72,1.88A18.28,18.28,0,0,1,45.4,351.16Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M54.45,339.4a12.13,12.13,0,0,1-1.64-2.92,11.85,11.85,0,0,1-1.22-3.11,12.18,12.18,0,0,1,1.64,2.91A12.43,12.43,0,0,1,54.45,339.4Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.87,328.29a8.43,8.43,0,0,1-1.8-2A8.17,8.17,0,0,1,63.65,324a8,8,0,0,1,1.8,2A7.76,7.76,0,0,1,66.87,328.29Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.45,382.8A18.19,18.19,0,0,1,46,384.94a17.57,17.57,0,0,1-3.69,1.73,17.8,17.8,0,0,1,3.47-2.14A17.32,17.32,0,0,1,49.45,382.8Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.25,374.14a13.9,13.9,0,0,1-3.17-1.51,13.54,13.54,0,0,1-2.94-1.92,13.4,13.4,0,0,1,3.17,1.51A13.12,13.12,0,0,1,64.25,374.14Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.37,354.34A9.27,9.27,0,0,1,65.32,356a9.44,9.44,0,0,1-3.34.87,19.19,19.19,0,0,1,3.17-1.3A21.06,21.06,0,0,1,68.37,354.34Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M73.08,339.42A5.85,5.85,0,0,1,71.79,337a5.66,5.66,0,0,1-.48-2.69,13.29,13.29,0,0,1,.93,2.54A13.27,13.27,0,0,1,73.08,339.42Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M62.57,393.56a14.15,14.15,0,0,1,1.33-3.33,14.5,14.5,0,0,1,1.75-3.13,13.17,13.17,0,0,1-1.33,3.33A13.46,13.46,0,0,1,62.57,393.56Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M87.56,388.25a10.23,10.23,0,0,1-2.9-2.6,10.4,10.4,0,0,1-2.11-3.25,36.58,36.58,0,0,1,2.47,3A37.62,37.62,0,0,1,87.56,388.25Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M96.22,366.46a18.84,18.84,0,0,1-3.46,2.25,18.08,18.08,0,0,1-3.69,1.84,18.41,18.41,0,0,1,3.46-2.25A17.47,17.47,0,0,1,96.22,366.46Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90.39,353.05a16.54,16.54,0,0,1,2.68-2.85,16.73,16.73,0,0,1,3-2.51,16.61,16.61,0,0,1-2.68,2.85A16.73,16.73,0,0,1,90.39,353.05Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90.65,338.83a12.21,12.21,0,0,1-2.73-1.92,12.12,12.12,0,0,1-2.44-2.28,12,12,0,0,1,2.73,1.92A12.12,12.12,0,0,1,90.65,338.83Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M107.17,329.42a12.36,12.36,0,0,1-2.71,2,12.25,12.25,0,0,1-3,1.66,12.58,12.58,0,0,1,2.71-2.05A12.4,12.4,0,0,1,107.17,329.42Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M113.54,342.45a8.85,8.85,0,0,1-2.84.44,8.93,8.93,0,0,1-2.86,0,9.08,9.08,0,0,1,2.83-.44A9.37,9.37,0,0,1,113.54,342.45Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.69,357.87a14.85,14.85,0,0,1-3.61-.12,14,14,0,0,1-3.57-.58,14.86,14.86,0,0,1,3.61.12A13.92,13.92,0,0,1,117.69,357.87Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M115.63,377.74a21.65,21.65,0,0,1-3.32-3,22.43,22.43,0,0,1-3-3.36,22.08,22.08,0,0,1,3.32,3A22.11,22.11,0,0,1,115.63,377.74Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M110.21,393.05a21.88,21.88,0,0,1-5.94-7.12c.11-.08,1.31,1.62,3,3.58S110.3,393,110.21,393.05Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 38.02,
					y: 397.13,
					width: 79.19,
					height: 14.04,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "44.52 407.56 54.15 449.51 101.35 449.51 111.88 407.56 44.52 407.56",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.17,411.19c0,.15-17.86.28-39.89.28s-39.9-.13-39.9-.28,17.86-.28,39.9-.28S117.17,411,117.17,411.19Z",
					style: { fill: "#e0e0e0" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Character--inject-3",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M332.72,227.54c-.6-9.41-4.56-18.39-10.11-26-2.79-3.84-6.08-7.57-7.08-12.21-1.32-6.18,1.61-13.27-1.77-18.62-2.37-3.77-7.19-5.33-9.89-8.87-2.91-3.8-2.84-9.05-4.56-13.51s-7.52-8.3-11.07-5.08c-.68-8.41.68-13.13-6.49-17.56s-21.31-2.29-24.06,5.68c-6.1-5.1-17.25-10-24.26-6.26-4.32,2.32-7.63,6.12-11.65,8.94-6.23,4.36-13.84,6.17-20.81,9.24s-13.86,8.16-15.48,15.6c-1.19,5.49.73,11.26-.28,16.78-.86,4.65-3.7,8.64-5.88,12.83a48.89,48.89,0,0,0-4.16,11.08c-1.82,7.5-.81,17.17,6.19,20.42a11.18,11.18,0,0,0,2.24,21.9l-11.79,21.37c-1.09,2-2.22,4.16-1.85,6.39.52,3.11,3.89,5.07,7,5.1s6.11-1.38,8.93-2.76a11.35,11.35,0,0,0,20.28-.54,13.93,13.93,0,0,0,24.42.13l47.88-11,36.1-3.33c5.24-.49,11.08-1.3,14.29-5.46,2.08-2.71,2.56-6.29,3-9.68A80.31,80.31,0,0,0,332.72,227.54Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M249.12,360,226,298.66l12-12-.47-3.86c-1.31-9.65-1.79-13.61-1.79-13.52s-20.8-.87-28.3-26.94c-3.73-13-5.74-34.74-6.81-52.6-1-16.08,7.2-37,23.3-37.23l51.19,6.43a9.42,9.42,0,0,1,9.54,8.45L293.53,275l6.79,5.81,8.18,74.53Z",
					style: { fill: "#b47266" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M212.4,210.48a3.43,3.43,0,0,0,3.71,3,3.28,3.28,0,0,0,3.14-3.5,3.44,3.44,0,0,0-3.71-3A3.29,3.29,0,0,0,212.4,210.48Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M246.5,207.58a3.43,3.43,0,0,0,3.71,3,3.28,3.28,0,0,0,3.13-3.51,3.41,3.41,0,0,0-3.7-3A3.28,3.28,0,0,0,246.5,207.58Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M206.76,202.2c.48.39,2.82-1.84,6.5-2.28s6.58,1.06,6.93.56c.17-.22-.36-1-1.64-1.68a9.43,9.43,0,0,0-5.62-1,9,9,0,0,0-5.1,2.37C206.81,201.18,206.53,202,206.76,202.2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M243.23,199.2c.48.39,2.83-1.84,6.5-2.28s6.58,1.06,6.93.56c.17-.22-.36-1-1.64-1.68a9.43,9.43,0,0,0-5.62-1,9.08,9.08,0,0,0-5.1,2.37C243.28,198.18,243,199,243.23,199.2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M233,225.51c0-.21-2.33-.33-6.09-.34-1,0-1.86-.06-2.1-.68a4.87,4.87,0,0,1,.29-2.86l1.89-7.47c2.6-10.64,4.35-19.33,3.92-19.44s-2.88,8.44-5.48,19.08c-.61,2.62-1.2,5.11-1.77,7.5-.22,1.11-.68,2.39,0,3.74a2.38,2.38,0,0,0,1.71,1.18,6.33,6.33,0,0,0,1.62,0C230.66,226,233,225.72,233,225.51Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M235.77,269.25a68.19,68.19,0,0,0,34.45-13.89s-6.67,19.64-33.6,20.43Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M234.24,234.94c2-2.27,7.53-5.88,9.35-6.33s1.71,1.78,3,3.36a5.92,5.92,0,0,1,.63,6.11c-1.13,2.23-3.51,4.16-5.68,3.92s-4.21-2.41-6-3.66a4,4,0,0,1-1.34-1.26,2,2,0,0,1-.08-1.93",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M239.31,185.68c.48.95,4.09,0,8.46,0s8,.74,8.45-.23c.21-.46-.51-1.32-2-2.11a14,14,0,0,0-6.46-1.41,14.15,14.15,0,0,0-6.43,1.57C239.79,184.34,239.09,185.22,239.31,185.68Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M206.25,189.34c.75.75,3.17-.42,6.21-.84s5.68-.13,6.16-1.07c.21-.46-.3-1.25-1.52-1.9a9.07,9.07,0,0,0-10,1.55C206.16,188.07,205.92,189,206.25,189.34Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M281.75,200.63c.34-.22,14.17-6.68,16,8.17S284.24,222.39,284.16,222,281.75,200.63,281.75,200.63Z",
					style: { fill: "#b47266" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M288,215.8c.06-.06.28.15.74.29a2.59,2.59,0,0,0,1.94-.19c1.5-.77,2.52-3.42,2.26-6.1a8.5,8.5,0,0,0-1.17-3.62,3,3,0,0,0-2.18-1.75,1.35,1.35,0,0,0-1.45.9c-.14.44,0,.72-.09.76s-.35-.21-.3-.84a1.58,1.58,0,0,1,.47-1,1.91,1.91,0,0,1,1.38-.55,3.63,3.63,0,0,1,3,2,8.73,8.73,0,0,1,1.4,4c.27,3-.92,6-3,6.87a2.79,2.79,0,0,1-2.42-.11C288.09,216.15,288,215.83,288,215.8Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M294.92,220.06c0,.06.41.13,1.05.49a4.89,4.89,0,0,1,2,2.27,4.23,4.23,0,0,1-.36,4.24,5,5,0,0,1-4.74,2.09,5.38,5.38,0,0,1-3.74-7.77,6.72,6.72,0,0,1,2-2.36,8,8,0,0,0,1-.66,2.74,2.74,0,0,0-1.11.44,6.34,6.34,0,0,0-2.26,2.36,5.74,5.74,0,0,0-.43,4.82,5.94,5.94,0,0,0,4.48,3.84,5.58,5.58,0,0,0,5.37-2.41,4.63,4.63,0,0,0,.81-2.55,5,5,0,0,0-.54-2.25,4.8,4.8,0,0,0-2.33-2.29A2.14,2.14,0,0,0,294.92,220.06Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240,241.56c0-.05.16,0,.36.07a5,5,0,0,0,.82.37,3.8,3.8,0,0,0,3-.77,6.78,6.78,0,0,0,1.77-1.34,7.72,7.72,0,0,0,1.43-2.07,4.1,4.1,0,0,0,.29-2.54,6.3,6.3,0,0,0-1.36-2.57c-1.32-1.65-3-3.05-4.56-2.93a5.32,5.32,0,0,0-2.25.88c-.71.45-1.39.9-2,1.31-2.41,1.63-3.36,3.17-3.56,3.07s0-.52.47-1.26a11.41,11.41,0,0,1,2.41-2.68c.58-.49,1.22-1,2-1.51a6,6,0,0,1,2.83-1.24,5.14,5.14,0,0,1,3.37,1,11.89,11.89,0,0,1,2.54,2.42,7.57,7.57,0,0,1,1.64,3.23,5.49,5.49,0,0,1-.48,3.45,7,7,0,0,1-.85,1.33,11,11,0,0,1-1,1.06,7.19,7.19,0,0,1-2.19,1.4,6.76,6.76,0,0,1-2,.64,2.51,2.51,0,0,1-2.44-1C240.07,241.71,240,241.6,240,241.56Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M294.6,246.9a.58.58,0,0,1,.21,0l.58.06a13.19,13.19,0,0,0,2.29-.05,14.77,14.77,0,0,0,7.81-3.4,21.71,21.71,0,0,0,6.7-11.26,28.27,28.27,0,0,0,1-8.06,17.94,17.94,0,0,0-2.31-8.55l-.06-.1.05-.11a18.58,18.58,0,0,0-9.62-24.9l-.39-.17.33-.28a6,6,0,0,0,1.6-2,8.35,8.35,0,0,0,.33-6.21,16,16,0,0,0-3.19-5.4,16.6,16.6,0,0,0-4.65-3.94,7.91,7.91,0,0,0-5.62-1l-.58.14.31-.51a9.11,9.11,0,0,0-10-13.62l-.34.09.1-.34a12,12,0,0,0-2.2-10.82,9.6,9.6,0,0,0-1.81-1.64,8.3,8.3,0,0,0-2-1,9.35,9.35,0,0,0-3.93-.47,9.48,9.48,0,0,0-3.09.82,8.43,8.43,0,0,0-1.95,1.29,12.73,12.73,0,0,0-1.29,1.47,3.14,3.14,0,0,1,.26-.42,6,6,0,0,1,.95-1.13,8.12,8.12,0,0,1,2-1.37,9.56,9.56,0,0,1,3.13-.88,9.38,9.38,0,0,1,4.05.43,8.47,8.47,0,0,1,2.1,1,10.22,10.22,0,0,1,1.89,1.68,12.36,12.36,0,0,1,2.34,11.14l-.25-.25a9.56,9.56,0,0,1,10.48,14.27l-.27-.37a8.51,8.51,0,0,1,6,1,17.08,17.08,0,0,1,4.8,4.06,16.44,16.44,0,0,1,3.29,5.57,8.79,8.79,0,0,1-.36,6.6,6.38,6.38,0,0,1-1.73,2.19l-.06-.44a19,19,0,0,1,9.83,25.57v-.21a18.1,18.1,0,0,1,2.34,8.77,28.18,28.18,0,0,1-1.07,8.17,21.76,21.76,0,0,1-6.9,11.38,14.7,14.7,0,0,1-8,3.33,12.05,12.05,0,0,1-2.31,0l-.59-.1Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M289.65,193.45c-.39-10.07-.82-20.35-4.43-29.76a13.47,13.47,0,0,0-3.59-5.72,13.26,13.26,0,0,0-5-2.31c-2.79-.79-3.55-2.68-6.44-2.89-11-9.35-26.79-12.55-40.73-8.79s-25.81,14.21-31.83,27.34a55.67,55.67,0,0,0-1.2,42.2c-.93-10.7,5.85-20.73,14.16-27.54s18.25-11.33,27-17.5a10.39,10.39,0,0,1-4,7.66c6.94-1.86,14-3.76,20.25-7.22a38.51,38.51,0,0,0,4.07-2.56,12.85,12.85,0,0,0,1.33,4.69c2.35,4.61,7.39,7.07,11.23,10.54a4.06,4.06,0,0,1,1.17,1.47,4.63,4.63,0,0,1-.19,2.86,22.42,22.42,0,0,0-1,9.29c.47,3.1,2.21,6.15,5,7.5a9.31,9.31,0,0,0,.58,10.8,2.4,2.4,0,0,0,1.35.94c.91.13,1.67-.66,2.19-1.42a19.22,19.22,0,0,0,3.09-7.37,7.13,7.13,0,0,1,1-3.19c1-1.27,2.86-1.53,4.09-2.6C289.69,198.36,289.74,195.74,289.65,193.45Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M211.44,170.18a4.63,4.63,0,0,1,.2-.75,10.08,10.08,0,0,1,1-2,10.87,10.87,0,0,1,6.43-4.76l-.15.18a22.05,22.05,0,0,1,.89-4.26,23.41,23.41,0,0,1,2-4.46,22.36,22.36,0,0,1,7.75-7.72,18.71,18.71,0,0,1,4.56-2,6.88,6.88,0,0,1,2.43-.18,3.29,3.29,0,0,1,2.13,1.1h-.39a19.13,19.13,0,0,1,6.76-5.49c2.36-1.17,4.82-1.66,6.73-1.09a4.89,4.89,0,0,1,3.29,3,3.41,3.41,0,0,1,.19,1.2,1.13,1.13,0,0,1-.06.41,4.37,4.37,0,0,0-.29-1.55,4.77,4.77,0,0,0-3.21-2.73c-1.82-.5-4.17,0-6.46,1.17a19,19,0,0,0-6.56,5.41l-.19.24-.19-.23c-.9-1.08-2.59-1.11-4.06-.74a18.41,18.41,0,0,0-4.42,1.92,22.23,22.23,0,0,0-7.59,7.53,22.84,22.84,0,0,0-2,4.35,22.12,22.12,0,0,0-.93,4.16V163l-.13,0a10.85,10.85,0,0,0-6.35,4.49A17.41,17.41,0,0,0,211.44,170.18Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M193.39,259.63l-.25.38-.8,1.13-.06.08,0-.1a31.55,31.55,0,0,1-1.59-10A33.27,33.27,0,0,1,195.43,234l.09.28a11.54,11.54,0,0,1-6.61-10.31,10.16,10.16,0,0,1,.52-3.47,9.49,9.49,0,0,0,.48-1.64,1.88,1.88,0,0,0-.45-1.48,11.61,11.61,0,0,0-1.29-1.21,16.3,16.3,0,0,1-1.32-1.31,17.83,17.83,0,0,1-2.2-3.07,17,17,0,0,1,1.54-18.92,16.12,16.12,0,0,1,1.41-1.57c.5-.48,1-.95,1-1.54a8.28,8.28,0,0,0-.55-1.93,16.24,16.24,0,0,1-.57-2.07,19.41,19.41,0,0,1-.44-4.31,21.07,21.07,0,0,1,7.4-16.08c1.12-.95,2.38-1.7,2.93-3a10.7,10.7,0,0,0,.61-2c.18-.69.41-1.37.61-2.05a21.79,21.79,0,0,1,4.19-7.12,24,24,0,0,1,13-7.7,23.55,23.55,0,0,1,6.91-.34,2.83,2.83,0,0,0,1.49-.28,7.31,7.31,0,0,0,1.16-1l1.16-1.09,1.21-1a25.6,25.6,0,0,1,5-2.94,26.48,26.48,0,0,1,4.93-1.58,25.23,25.23,0,0,1,8.24-.45A24,24,0,0,1,251,136l1.26.5.43.19-.45-.14-1.27-.45a26.22,26.22,0,0,0-5.09-1,25.57,25.57,0,0,0-8.16.53,26.94,26.94,0,0,0-4.85,1.6,25.73,25.73,0,0,0-4.92,2.93l-1.18,1-1.14,1.08a7,7,0,0,1-1.24,1.09,3.14,3.14,0,0,1-1.69.34c-.57,0-1.12-.08-1.68-.08a13.45,13.45,0,0,0-1.68,0,22.94,22.94,0,0,0-3.45.44,23.68,23.68,0,0,0-12.71,7.59,21.25,21.25,0,0,0-4.08,7c-.19.66-.42,1.32-.59,2a11.57,11.57,0,0,1-.64,2.08c-.63,1.44-2,2.24-3.07,3.16a20.6,20.6,0,0,0-7.2,15.68,19,19,0,0,0,.43,4.2,15.93,15.93,0,0,0,.56,2,7.93,7.93,0,0,1,.57,2.11,2.91,2.91,0,0,1-1.19,1.89,17.9,17.9,0,0,0-1.37,1.52,16.56,16.56,0,0,0,.62,21.35,15.35,15.35,0,0,0,1.27,1.28,10.6,10.6,0,0,1,1.34,1.27,2.34,2.34,0,0,1,.55,1.83,9,9,0,0,1-.51,1.73,10,10,0,0,0-.51,3.31,11.16,11.16,0,0,0,6.32,10l.2.09-.11.19a32.24,32.24,0,0,0-3.8,9,33.41,33.41,0,0,0,.39,17.95h-.09l.83-1.1A4.47,4.47,0,0,1,193.39,259.63Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M282.54,127.53a41.46,41.46,0,0,0-4.73-.33,11.51,11.51,0,0,0-4.89,1.18,7.94,7.94,0,0,0-4,4.45,6.6,6.6,0,0,0-.24,1.08l0,.24h-.23a13,13,0,0,0-5.67,1.06,8.81,8.81,0,0,0-3.59,2.93,7.81,7.81,0,0,0-1.28,2.86c-.15.73-.16,1.15-.2,1.15s0-.1,0-.3a5.05,5.05,0,0,1,.05-.88,7.3,7.3,0,0,1,1.18-3,9,9,0,0,1,3.68-3.15,13,13,0,0,1,5.89-1.16l-.27.23a6.32,6.32,0,0,1,.26-1.17A8.33,8.33,0,0,1,272.7,128a11.62,11.62,0,0,1,5.11-1.12,17.61,17.61,0,0,1,3.49.36A5.19,5.19,0,0,1,282.54,127.53Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "241.22 349.46 315.62 346.91 322.52 448.51 257.42 449.42 241.22 349.46",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M299.12,274c1-1.27,56.49,36.37,59,40.87S374,449.43,374,449.43l-72.49,0s-6.66-107.12-6.31-117S299.12,274,299.12,274Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.8,450s-8.18-16.83-7.27-25,7.27-24.56,7.27-24.56l16.37-29.1s3.28-24.25,5.09-28.8S164.66,307.23,176,300s45.82-12.19,45.82-12.19l15.27-11.34s15.19,44.85,17.46,57.13,15,116.4,15,116.4Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M259.45,371.77a1,1,0,0,1-.17-.22l-.47-.65-1.74-2.56-6.32-9.44c-2.66-4-5.81-8.77-9.32-14l-5.48-8.3c-1.88-2.87-3.92-6-4.61-9.68a15.25,15.25,0,0,1,.37-6.63,45.94,45.94,0,0,1,2.1-6l.31.33-10,3.48-.28.09,0-.3c-.67-8.71-1.23-16.05-1.63-21.26-.18-2.56-.32-4.59-.42-6,0-.67-.07-1.19-.09-1.59a3.27,3.27,0,0,1,0-.55,3.25,3.25,0,0,1,.08.54c0,.4.1.92.17,1.59.13,1.43.31,3.46.55,6,.44,5.2,1.07,12.54,1.81,21.25l-.31-.2,10-3.52.52-.18-.2.52a45.08,45.08,0,0,0-2.07,5.93,14.74,14.74,0,0,0-.36,6.41c.66,3.56,2.66,6.62,4.52,9.49s3.72,5.66,5.46,8.32l9.23,14.1,6.18,9.54,1.66,2.61.42.68C259.41,371.68,259.46,371.76,259.45,371.77Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M207.15,447.81a1,1,0,0,1-.1-.31l-.24-.92c-.2-.85-.48-2-.85-3.56-.71-3.12-1.73-7.59-3-13.1-2.44-11.11-5.8-26.4-9.52-43.29L184,343.31c-1.22-5.52-2.2-10-2.89-13.12q-.49-2.29-.78-3.57c-.08-.39-.14-.7-.19-.93a1.14,1.14,0,0,1,0-.33s0,.11.09.31.15.54.24.92c.21.85.51,2,.88,3.55.74,3.09,1.79,7.56,3,13.09,2.52,11.06,5.9,26.37,9.58,43.29s7,32.21,9.37,43.32c1.18,5.53,2.15,10,2.82,13.14.32,1.53.58,2.72.76,3.57.07.39.13.7.18.94S207.15,447.81,207.15,447.81Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .30000000000000004 },
					children: /* @__PURE__ */ _jsx("path", { d: "M200.57,448.51a55.48,55.48,0,0,1,24.14-7.6c6.55-.48,13.31.19,19.56-1.84,7-2.27,12.51-7.63,17.74-12.83a12.85,12.85,0,0,0,3.53-4.83c.63-1.91.1-4.36-1.69-5.28-1.38-.71-3.05-.34-4.55.08a156.24,156.24,0,0,0-59.91,31.85" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M181.19,411s-.4-.56-1.09-1.59a38.93,38.93,0,0,0-3.23-4.1,36.24,36.24,0,0,0-30.91-12,38.44,38.44,0,0,0-5.15.86,18.36,18.36,0,0,1-1.88.44,1.6,1.6,0,0,1,.47-.19c.31-.11.76-.28,1.36-.44a31.48,31.48,0,0,1,5.16-1,35.49,35.49,0,0,1,31.23,12.09,32.51,32.51,0,0,1,3.12,4.24c.34.53.55,1,.71,1.24S181.21,411,181.19,411Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M189.15,407.05s-.1-.15-.24-.46l-.57-1.36c-.24-.59-.53-1.31-.94-2.12s-.8-1.76-1.38-2.75l-.86-1.57c-.3-.54-.66-1.08-1-1.65-.68-1.16-1.54-2.31-2.4-3.54a55,55,0,0,0-14.2-13.34c-1.28-.8-2.48-1.58-3.67-2.18-.59-.32-1.15-.65-1.71-.92l-1.62-.76c-1-.51-2-.86-2.83-1.2a21.65,21.65,0,0,0-2.18-.81l-1.39-.49a1.73,1.73,0,0,1-.47-.21,2.31,2.31,0,0,1,.5.11l1.42.39a22.56,22.56,0,0,1,2.22.73c.85.33,1.84.65,2.88,1.15l1.64.73c.57.26,1.14.59,1.74.89,1.22.6,2.43,1.38,3.73,2.16a57.1,57.1,0,0,1,7.79,6.07,56.53,56.53,0,0,1,6.53,7.4c.87,1.25,1.71,2.42,2.39,3.59.34.58.7,1.13,1,1.68l.84,1.6c.56,1,.94,2,1.31,2.8a21.24,21.24,0,0,1,.87,2.17l.48,1.39A2.52,2.52,0,0,1,189.15,407.05Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M340.35,358.8a.61.61,0,0,1,0,.22l-.14.67c-.14.62-.33,1.46-.58,2.53-.51,2.19-1.26,5.37-2.11,9.31a163.92,163.92,0,0,0-3.93,31.17,88.73,88.73,0,0,0,1.23,17.23,70.08,70.08,0,0,0,3.71,13.61,62.27,62.27,0,0,0,4.09,8.59c.55,1,1.05,1.71,1.34,2.22l.35.58a1.1,1.1,0,0,1,.1.21s-.06-.05-.15-.18l-.39-.55c-.32-.5-.85-1.2-1.42-2.18a56.6,56.6,0,0,1-4.26-8.56A68.28,68.28,0,0,1,334.32,420,87.38,87.38,0,0,1,333,402.69a155.73,155.73,0,0,1,4.09-31.24c.89-3.94,1.7-7.1,2.27-9.28.29-1.06.52-1.89.68-2.51.08-.26.14-.47.19-.65Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M333.34,401.18a4,4,0,0,1,0-.76q.08-.81.18-2.16c.1-.93.18-2.08.28-3.41s.21-2.85.31-4.53c.42-6.71.71-16,.64-26.26s-.48-19.55-.91-26.26c-.2-3.36-.41-6.07-.56-7.95-.06-.9-.11-1.61-.15-2.16a3.17,3.17,0,0,1,0-.76,5.25,5.25,0,0,1,.12.75c.06.54.15,1.26.26,2.15.2,1.87.47,4.59.72,7.94.52,6.71,1,16,1.06,26.29s-.28,19.57-.8,26.28c-.11,1.68-.24,3.2-.38,4.53s-.24,2.48-.36,3.41-.21,1.61-.28,2.15A6,6,0,0,1,333.34,401.18Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M312.57,307.28a3,3,0,0,1-.21.84,5.18,5.18,0,0,1-1.44,2,7.4,7.4,0,0,1-3.52,1.7,20.59,20.59,0,0,1-5.19.23l.05-.36,6.71,1.66.19,0,0,.18c-.65,6.58-1.61,14.46-3,22.87-1.87,11.55-4.18,21.9-6,29.34-.94,3.71-1.75,6.71-2.34,8.77-.29,1-.52,1.78-.7,2.36a7.19,7.19,0,0,1-.27.82,4.51,4.51,0,0,1,.17-.84c.15-.6.35-1.39.61-2.4.52-2.07,1.28-5.08,2.18-8.8,1.76-7.45,4-17.8,5.88-29.33C307,328,308,320.1,308.7,313.54l.17.23-6.7-1.73.06-.36a21.14,21.14,0,0,0,5.11-.14,7.38,7.38,0,0,0,3.45-1.57,5.23,5.23,0,0,0,1.47-1.89C312.49,307.57,312.54,307.28,312.57,307.28Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .30000000000000004 },
					children: /* @__PURE__ */ _jsx("path", { d: "M182.82,337.82a15.77,15.77,0,0,0-3.7-3.77,3,3,0,0,0-4.84,3.14,10.27,10.27,0,0,0,1.31,3.14,112,112,0,0,1,12.5,37.81c.8,5.66,1.16,11.4,2.38,17s2.48,9.83,6.37,14l1.6-.68a42.19,42.19,0,0,0-.78-4.47c-5.21-21.73-9.77-43.41-14.84-66.17" })
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .30000000000000004 },
					children: /* @__PURE__ */ _jsx("path", { d: "M181.86,411.22c-.69-5.2-4-9.79-8.19-13s-9.19-5-14.21-6.56a24.82,24.82,0,0,0-8.34-1.38c-2.83.16-8.13,1.37-9.79,3.67,18.73-4.42,32.34,4.27,39.82,17.66" })
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .30000000000000004 },
					children: /* @__PURE__ */ _jsx("path", { d: "M334,344.06c-1.42,15.4-5.56,30.43-7.4,45.78S325.47,421.52,333,435c2.54,4.53,6.13,8.87,11.11,10.38-5.93-7.12-8.85-16.34-9.92-25.55s-.45-18.5,0-27.76q1.05-24,.08-48" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M185.14,348.6a7.29,7.29,0,0,1-1.23.53,34.2,34.2,0,0,1-3.49,1.1,44.46,44.46,0,0,1-5.32,1,47.81,47.81,0,0,1-6.64.38,49,49,0,0,1-6.62-.63,40.94,40.94,0,0,1-5.28-1.25,32.4,32.4,0,0,1-3.44-1.23,7.61,7.61,0,0,1-1.21-.57,5.63,5.63,0,0,1,1.28.38c.81.29,2,.67,3.47,1.07a51.27,51.27,0,0,0,5.26,1.13,48.58,48.58,0,0,0,13.12.25,48.28,48.28,0,0,0,5.29-.93c1.49-.35,2.69-.68,3.51-.94A5.55,5.55,0,0,1,185.14,348.6Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.17,337.85a22.42,22.42,0,0,1-4,2.69,30.66,30.66,0,0,1-21.68,2.88,29.31,29.31,0,0,1-9.54-4.25,31.49,31.49,0,0,1-8.21-8.12,31,31,0,0,1-2.95-5.38,22.61,22.61,0,0,1-1.73-6.08,13.91,13.91,0,0,1,.51-6.32,7.89,7.89,0,0,1,4-4.65,8.54,8.54,0,0,1,5.92-.38,9.07,9.07,0,0,1,4.74,3.16,10.64,10.64,0,0,1,2,5,12.81,12.81,0,0,1-.37,5.11,15.49,15.49,0,0,1-5.09,7.5,23.16,23.16,0,0,1-6.51,3.76,38.91,38.91,0,0,1-5.44,1.6c-1.52.33-2.72.53-3.52.65l-.93.14a1.44,1.44,0,0,1-.31,0l.31-.08.91-.18c.8-.16,2-.39,3.49-.75a39.18,39.18,0,0,0,5.38-1.68,22.68,22.68,0,0,0,6.38-3.76,15.16,15.16,0,0,0,4.91-7.34,12.26,12.26,0,0,0,.33-4.92,10,10,0,0,0-1.95-4.8,8.52,8.52,0,0,0-4.5-3,8,8,0,0,0-5.56.36,7.38,7.38,0,0,0-3.73,4.36,13.37,13.37,0,0,0-.49,6.08,22.34,22.34,0,0,0,1.7,6,30.28,30.28,0,0,0,11,13.3,29,29,0,0,0,9.38,4.23,30.36,30.36,0,0,0,8.95.81,31.07,31.07,0,0,0,12.53-3.45,18.48,18.48,0,0,0,1.79-1c.51-.3.94-.57,1.27-.81l.77-.52Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M243.58,298.35c0,.09-1.27.19-3.3.57a35,35,0,0,0-7.67,2.37,35.84,35.84,0,0,0-6.93,4.06c-1.65,1.24-2.58,2.12-2.65,2a3.65,3.65,0,0,1,.6-.68,19,19,0,0,1,1.83-1.66,30.34,30.34,0,0,1,6.94-4.25,30.94,30.94,0,0,1,7.82-2.26,22.59,22.59,0,0,1,2.46-.23A3,3,0,0,1,243.58,298.35Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M260,376.26l-.35-.14-1-.44a27,27,0,0,0-4-1.31,28.51,28.51,0,0,0-15.11.55,29,29,0,0,0-9.33,4.82,35.15,35.15,0,0,0-8.16,8.88,39.54,39.54,0,0,0-5.26,12.24,12.83,12.83,0,0,0,.07,6.9,7.32,7.32,0,0,0,5.08,4.55,12.28,12.28,0,0,0,7.08-.16,14.11,14.11,0,0,0,5.88-3.67,10.47,10.47,0,0,0,2.88-5.94,9.16,9.16,0,0,0-.22-3.22,11.13,11.13,0,0,0-1.27-2.91,15.3,15.3,0,0,0-4.33-4.34,20.71,20.71,0,0,0-5.26-2.54,29.64,29.64,0,0,0-5.35-1.19,31,31,0,0,0-5.06-.16,30.41,30.41,0,0,0-14.47,4.46,28.83,28.83,0,0,0-3.39,2.44l-.83.7-.29.22a2.68,2.68,0,0,1,.25-.26l.8-.74a25.78,25.78,0,0,1,3.35-2.53,30.24,30.24,0,0,1,14.57-4.66,30.6,30.6,0,0,1,5.12.13,29.39,29.39,0,0,1,5.43,1.18,20.88,20.88,0,0,1,5.38,2.57,15.63,15.63,0,0,1,4.49,4.46,11.39,11.39,0,0,1,1.33,3.05,9.68,9.68,0,0,1,.25,3.4,11,11,0,0,1-3,6.23,14.65,14.65,0,0,1-6.09,3.82,12.81,12.81,0,0,1-7.39.16,7.87,7.87,0,0,1-5.42-4.88,13.28,13.28,0,0,1-.08-7.18,39.78,39.78,0,0,1,5.36-12.39,35.47,35.47,0,0,1,8.3-9,29.06,29.06,0,0,1,9.48-4.83,28.18,28.18,0,0,1,15.27-.39,23.3,23.3,0,0,1,4,1.41l1,.49Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168.78,380.21c0,.1-1.13.24-2.85.84a18.22,18.22,0,0,0-2.9,1.32,18.29,18.29,0,0,0-5.79,5.14,19.29,19.29,0,0,0-1.64,2.73c-.8,1.64-1.07,2.75-1.17,2.72a2.51,2.51,0,0,1,.13-.8,12,12,0,0,1,.7-2.08,16.85,16.85,0,0,1,1.59-2.85,18.7,18.7,0,0,1,2.67-3A18.26,18.26,0,0,1,162.8,382a15.3,15.3,0,0,1,3-1.25,11.33,11.33,0,0,1,2.15-.45A2.64,2.64,0,0,1,168.78,380.21Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M202.49,431.48s-.09-.07-.25-.23-.4-.43-.69-.73c-.6-.64-1.49-1.59-2.67-2.76a54.46,54.46,0,0,0-11-8.76,32.38,32.38,0,0,0-8.95-3.64,26.74,26.74,0,0,0-11-.25,19,19,0,0,0-10.52,5.8,10.68,10.68,0,0,0-2.67,5.7,7.77,7.77,0,0,0,1.74,6.09,6.15,6.15,0,0,0,5.87,1.9,4.87,4.87,0,0,0,2.6-1.65,6.53,6.53,0,0,0,1.32-2.8,8.45,8.45,0,0,0-1-5.92,12,12,0,0,0-4.08-4.23,17.13,17.13,0,0,0-10.63-2.26,40.47,40.47,0,0,0-9.47,2.05A51.24,51.24,0,0,0,128.48,426c-1.38.94-2.4,1.73-3.1,2.27l-.78.62c-.18.14-.27.21-.28.2a33.21,33.21,0,0,1,4-3.25A49.59,49.59,0,0,1,141,419.44a40.75,40.75,0,0,1,9.55-2.13,17.58,17.58,0,0,1,10.92,2.28,12.54,12.54,0,0,1,4.26,4.39,8.92,8.92,0,0,1,1.06,6.28,6.87,6.87,0,0,1-1.41,3,5.4,5.4,0,0,1-2.88,1.82,6.65,6.65,0,0,1-6.38-2.05,8.32,8.32,0,0,1-1.86-6.5,11.17,11.17,0,0,1,2.8-6,19.37,19.37,0,0,1,10.8-5.93,27.14,27.14,0,0,1,11.22.3,32.7,32.7,0,0,1,9,3.74,53.36,53.36,0,0,1,11,8.93c1.16,1.21,2,2.18,2.6,2.84l.65.76Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M333.58,403.24a3.77,3.77,0,0,1-.66.46c-.22.14-.49.32-.82.51l-1.18.59c-.45.22-1,.4-1.54.63s-1.21.37-1.89.56a22.4,22.4,0,0,1-4.78.56,20.59,20.59,0,0,1-11.82-3.71,12.85,12.85,0,0,1-4.78-5.64,5.94,5.94,0,0,1,0-4,4.5,4.5,0,0,1,3-2.74,8.62,8.62,0,0,1,7.61,1.9,8.42,8.42,0,0,1,2.35,3,6.27,6.27,0,0,1,.46,3.66,7.49,7.49,0,0,1-1.46,3.18,12.7,12.7,0,0,1-2.34,2.3,26.58,26.58,0,0,1-5,2.94,29.25,29.25,0,0,1-8.07,2.33c-1,.13-1.76.19-2.28.21a4,4,0,0,1-.8,0,4.53,4.53,0,0,1,.79-.1c.52-.06,1.28-.15,2.25-.31a30.85,30.85,0,0,0,8-2.46,26.36,26.36,0,0,0,4.92-2.95,9,9,0,0,0,3.6-5.22,6.69,6.69,0,0,0-2.66-6.22,8.13,8.13,0,0,0-7.14-1.79,4,4,0,0,0-2.69,2.43,5.33,5.33,0,0,0,0,3.63c.83,2.35,2.76,4.05,4.58,5.42a20.34,20.34,0,0,0,11.53,3.73,22.81,22.81,0,0,0,4.71-.47c.68-.18,1.31-.33,1.88-.52s1.09-.37,1.54-.57l1.19-.55c.34-.17.61-.34.84-.46A6.06,6.06,0,0,1,333.58,403.24Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M304.71,334.41a40.39,40.39,0,0,0-5.17,1.76,38.92,38.92,0,0,0-4.62,2.88,10.89,10.89,0,0,1,4.4-3.35A11.16,11.16,0,0,1,304.71,334.41Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M254.39,334.64a7.64,7.64,0,0,1-.79,2.31,18,18,0,0,1-3.35,4.85,18.23,18.23,0,0,1-4.73,3.52,7.79,7.79,0,0,1-2.29.86,27.53,27.53,0,0,0,6.65-4.74A27.18,27.18,0,0,0,254.39,334.64Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M319.65,287.46s-.71.13-2,.45a27.06,27.06,0,0,0-5.17,1.9,26.36,26.36,0,0,0-3.3,1.87,11.86,11.86,0,0,0-3.11,2.95,7.15,7.15,0,0,0-1.32,4.41,5.21,5.21,0,0,0,.69,2.32,4.36,4.36,0,0,0,1.85,1.62,4.09,4.09,0,0,0,2.42.37,3.06,3.06,0,0,0,2-1.21,4.27,4.27,0,0,0,.15-4.36,5,5,0,0,0-3.3-2.39,7.63,7.63,0,0,0-3.69.05,14,14,0,0,0-4.81,2.56c-1,.79-1.58,1.27-1.61,1.24s.11-.15.36-.39.62-.59,1.12-1a13.25,13.25,0,0,1,4.84-2.75,7.91,7.91,0,0,1,3.89-.12,5.41,5.41,0,0,1,3.63,2.59,4.76,4.76,0,0,1-.17,4.88,3.53,3.53,0,0,1-2.29,1.42,4.61,4.61,0,0,1-2.73-.41,4.81,4.81,0,0,1-2.07-1.82,5.67,5.67,0,0,1-.76-2.56,7.62,7.62,0,0,1,1.44-4.72,12.06,12.06,0,0,1,3.26-3,26.28,26.28,0,0,1,3.39-1.85,24.52,24.52,0,0,1,5.28-1.76c.64-.13,1.15-.19,1.49-.23A1.93,1.93,0,0,1,319.65,287.46Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.7,348.76a7.49,7.49,0,0,1-.52.68c-.18.21-.44.43-.73.72a9.28,9.28,0,0,1-1.16.79,10.69,10.69,0,0,1-8.71.68,11.54,11.54,0,0,1-5.09-3.47,16.45,16.45,0,0,1-3.3-6.26,22.19,22.19,0,0,1-.79-7.79,14,14,0,0,1,2.85-7.87,8.77,8.77,0,0,1,7.63-3.19,6.19,6.19,0,0,1,3.65,1.77,5.17,5.17,0,0,1,1.55,3.57,5,5,0,0,1-1.46,3.41,7.61,7.61,0,0,1-2.93,1.89,11.6,11.6,0,0,1-6.15.4,17.1,17.1,0,0,1-4.79-1.73,30.06,30.06,0,0,1-3.26-2c-.86-.61-1.51-1.1-1.94-1.44a5.34,5.34,0,0,1-.65-.54,4.42,4.42,0,0,1,.71.46l2,1.35a33.09,33.09,0,0,0,3.28,1.92,17.19,17.19,0,0,0,4.72,1.63,11.33,11.33,0,0,0,5.94-.44,7.11,7.11,0,0,0,2.74-1.8,4.57,4.57,0,0,0,1.32-3.1,4.73,4.73,0,0,0-1.42-3.23,5.75,5.75,0,0,0-3.37-1.61,8.3,8.3,0,0,0-7.15,3,13.5,13.5,0,0,0-2.75,7.58,21.75,21.75,0,0,0,.74,7.62,16.37,16.37,0,0,0,3.17,6.11,11.12,11.12,0,0,0,4.88,3.4,10.63,10.63,0,0,0,8.49-.5A9.76,9.76,0,0,0,332.7,348.76Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M360.77,341.56c0,.11-1.71-.5-4.54-.71a21,21,0,0,0-19,9.18,39.25,39.25,0,0,0-2.26,4,4.38,4.38,0,0,1,.38-1.19,18.14,18.14,0,0,1,1.57-3,20.4,20.4,0,0,1,19.32-9.35,17.69,17.69,0,0,1,3.34.65A5.53,5.53,0,0,1,360.77,341.56Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .30000000000000004 },
					children: /* @__PURE__ */ _jsx("path", { d: "M298.18,285.09c11.28,5.5,25,5.82,35.05,13.28A29.42,29.42,0,0,1,341,337c-.73-6.36-2-13.58-7.38-17-2.36-1.49-5.18-2-7.8-3-2.95-1.08-5.67-2.74-8.66-3.69-4-1.28-8.42-1.23-12.44-2.56s-7.93-4.76-7.63-9Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M340.88,335.26l-1.6-20.11s-10.91-2.11-14.78-4.57S313.55,303,313.55,303s-1.71,6.14-5.23,6.49l-3.17.36L305,297.47s-.6,5.56-5.17,6.42c-1,.2-1.05,0-1.05,0l-3.09-16.21s-3.66,4.74-10.35,1.58c0,0,10.84-18.9,12.95-19.6s13.51-1,13.51-1,15.83-1,17.59-.32,4.22,3.48,4.22,3.48,18.65,17.95,24.63,23.93a35.57,35.57,0,0,1,9.15,17.95c.36,3.16,3,16.35,3,16.35",
					style: { fill: "#b47266" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M370.45,330.1l-.09-.33-.21-1c-.18-.88-.45-2.15-.79-3.81s-.73-3.72-1.2-6.13c-.22-1.2-.46-2.5-.69-3.89-.12-.69-.18-1.42-.32-2.14s-.34-1.46-.56-2.21a38.74,38.74,0,0,0-4.27-9.39,31,31,0,0,0-3.55-4.63c-1.39-1.46-2.95-2.89-4.49-4.41L333.49,272h0a23.48,23.48,0,0,0-2-2,6.55,6.55,0,0,0-2.34-1.46,17.86,17.86,0,0,0-2.87-.17c-1,0-2,0-3,0-4,.09-8.07.34-12.26.54-2.09.06-4.2.14-6.32.26-1.06.06-2.13.13-3.2.22a17.37,17.37,0,0,0-3.12.47,4.62,4.62,0,0,0-1.08,1c-.34.42-.68.84-1,1.28-.64.88-1.26,1.78-1.87,2.7-1.21,1.82-2.39,3.7-3.56,5.6-1.81,3-3.57,5.92-5.26,8.85l-.12-.36a9.82,9.82,0,0,0,5.38,1,7.59,7.59,0,0,0,4.66-2.48l.36-.41.09.52c1.06,5.55,2.09,11,3.08,16.21v0h0c0-.15-.05-.11-.07-.14h.12a1.43,1.43,0,0,0,.29,0,4.08,4.08,0,0,0,.59-.11l.58-.16.55-.23a5.48,5.48,0,0,0,1.86-1.45,8.83,8.83,0,0,0,1.82-4.33l.48,0q0,6.42.1,12.4l-.25-.22,3.08-.34a3.93,3.93,0,0,0,2.46-1.32,13.15,13.15,0,0,0,2.68-5l.08-.27.24.16,6.74,4.66,3.17,2.2a14.2,14.2,0,0,0,3.19,1.78,53,53,0,0,0,6.53,2.11c2.11.55,4.12,1,6,1.4l.11,0v.11c.47,6.36.85,11.39,1.11,14.84.12,1.71.21,3,.28,3.93,0,.43,0,.77.06,1a2.86,2.86,0,0,1,0,.34s0-.11,0-.34-.06-.57-.1-1c-.08-.91-.2-2.22-.35-3.93-.29-3.45-.71-8.47-1.25-14.82l.12.12c-1.91-.37-3.92-.82-6-1.37a53,53,0,0,1-6.59-2.09,14.24,14.24,0,0,1-3.25-1.8l-3.19-2.19c-2.17-1.49-4.43-3-6.76-4.64l.32-.11a13.65,13.65,0,0,1-2.76,5.2,4.34,4.34,0,0,1-2.74,1.46l-3.07.35-.25,0v-.25q-.06-6-.13-12.41l.48,0a9.39,9.39,0,0,1-1.92,4.59,6.08,6.08,0,0,1-2,1.59l-.6.25-.63.17a4.66,4.66,0,0,1-.65.12l-.35,0-.2,0-.12,0a.2.2,0,0,1-.09-.05s-.07,0-.12-.2v0l-3.09-16.21.46.11a8.07,8.07,0,0,1-5,2.68,10.28,10.28,0,0,1-5.66-1l-.25-.12.14-.24q2.55-4.42,5.27-8.87c1.17-1.9,2.35-3.78,3.57-5.62.61-.92,1.23-1.83,1.89-2.72.32-.44.66-.87,1-1.3a4.63,4.63,0,0,1,1.29-1.18,17.37,17.37,0,0,1,3.27-.49c1.07-.1,2.15-.16,3.21-.23,2.13-.11,4.25-.19,6.34-.25,4.16-.19,8.26-.44,12.26-.52,1,0,2,0,3,0a19,19,0,0,1,3,.19,6.9,6.9,0,0,1,2.53,1.57,21.93,21.93,0,0,1,2.05,2v0l20.73,20.2c1.55,1.53,3.09,3,4.49,4.43a31.59,31.59,0,0,1,3.57,4.71,38.68,38.68,0,0,1,4.26,9.49c.21.76.41,1.5.54,2.24s.2,1.46.32,2.15c.21,1.39.43,2.68.65,3.89.44,2.41.82,4.47,1.13,6.15s.55,2.93.72,3.82c.07.42.13.74.17,1S370.45,330.1,370.45,330.1Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M314.52,269.66c0,.09-1.66.39-4.24,1.28a65,65,0,0,0-9.69,4.41,9.05,9.05,0,0,0-2.39,1.75,7.8,7.8,0,0,0-1.47,2.31,10.64,10.64,0,0,0-.92,4.59c0,1.36.1,2.47.11,3.23a4.54,4.54,0,0,1-.05,1.2,5.86,5.86,0,0,1-.16-1.18c-.07-.77-.22-1.86-.27-3.24a10.59,10.59,0,0,1,.85-4.79,7.94,7.94,0,0,1,1.54-2.47,9.53,9.53,0,0,1,2.51-1.86,54,54,0,0,1,9.83-4.3,29.22,29.22,0,0,1,3.16-.79A4.54,4.54,0,0,1,314.52,269.66Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M326.4,273.2a10.18,10.18,0,0,1-1.54.47c-1,.3-2.43.7-4.15,1.36a36.12,36.12,0,0,0-5.8,2.85c-1.06.61-2.18,1.26-3.37,1.88s-2.48,1.16-3.63,1.89a5.43,5.43,0,0,0-1.48,1.33,5.59,5.59,0,0,0-.81,1.75,22.1,22.1,0,0,0-.62,3.74,48.4,48.4,0,0,0,0,6.47c.09,1.85.18,3.35.2,4.39a9.17,9.17,0,0,1,0,1.61,10.19,10.19,0,0,1-.18-1.6c-.09-1.13-.22-2.6-.37-4.38a44.58,44.58,0,0,1-.08-6.53,22.79,22.79,0,0,1,.61-3.84,6.11,6.11,0,0,1,.88-1.91,5.78,5.78,0,0,1,1.61-1.47c1.24-.77,2.52-1.27,3.69-1.9s2.29-1.25,3.36-1.85a35.57,35.57,0,0,1,5.91-2.78,39.29,39.29,0,0,1,4.23-1.2A8.26,8.26,0,0,1,326.4,273.2Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.2,278.47a6.71,6.71,0,0,1-1.28.5c-.83.3-2,.73-3.49,1.34A30.31,30.31,0,0,0,317.22,287a15.9,15.9,0,0,0-3.46,5.67,16.48,16.48,0,0,0-.91,5.39,22.58,22.58,0,0,0,.7,5s-.07-.1-.16-.32a8.72,8.72,0,0,1-.33-1,14.06,14.06,0,0,1-.58-3.73,16,16,0,0,1,4.37-11.42A28.74,28.74,0,0,1,327.29,280c1.49-.57,2.71-1,3.57-1.19A6.61,6.61,0,0,1,332.2,278.47Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M338.23,291s-.06.09-.24.2a2.46,2.46,0,0,1-.85.31,6.26,6.26,0,0,1-3.25-.5,11.58,11.58,0,0,0-2.11-.62,4.78,4.78,0,0,0-2.42.28,26.93,26.93,0,0,0-5,3,15.59,15.59,0,0,0-4.12,4,20.89,20.89,0,0,1-2.63,4.07,6.39,6.39,0,0,1-1.5,1.16,2.74,2.74,0,0,1-1.41.32,3.16,3.16,0,0,1-.89-.16c-.19-.07-.29-.11-.28-.13s.42.1,1.17.09a2.73,2.73,0,0,0,1.27-.38,6.27,6.27,0,0,0,1.38-1.15,24.11,24.11,0,0,0,2.49-4.08,15.09,15.09,0,0,1,4.22-4.21c.86-.62,1.71-1.18,2.54-1.72a11.93,11.93,0,0,1,2.58-1.33,5.19,5.19,0,0,1,2.65-.26,12,12,0,0,1,2.17.7,6.45,6.45,0,0,0,3.09.65A5.27,5.27,0,0,0,338.23,291Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M345.13,314.58a3,3,0,0,1-.75-.47,17,17,0,0,1-1.85-1.54A25.4,25.4,0,0,1,335,298.82a16.78,16.78,0,0,1-.31-2.39,2.6,2.6,0,0,1,0-.88c.09,0,.2,1.24.66,3.2a28.63,28.63,0,0,0,7.45,13.56C344.19,313.74,345.19,314.51,345.13,314.58Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M360.82,311.48a5.49,5.49,0,0,1-1.42,1.75,12.31,12.31,0,0,1-4.75,2.67,12.18,12.18,0,0,1-5.44.34,5.72,5.72,0,0,1-2.15-.68c0-.09.85.17,2.2.32a13.45,13.45,0,0,0,9.89-2.93C360.21,312.09,360.75,311.42,360.82,311.48Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M381,442.57a23.79,23.79,0,0,1-32.93-3c-4.6-5.38-8.25-12-7.69-19.07,1.42-17.75.56-88.07.56-88.07l28.22-7.25s21.75,85,22.82,99.83C392.47,431.5,387.15,437.68,381,442.57Z",
					style: { fill: "#b47266" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.81,412.77h32.38l17.92-6.3,5.21-13.88s10.52-8,21.45,2.1S248.44,425,248.44,425l-29,10.1s-18.09,13.52-20.2,13.56l-57.89.78S140.77,423.71,153.81,412.77Z",
					style: { fill: "#b47266" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M227.89,406.25l-3.79-61.17a4,4,0,0,1,4-4.21h33.35a4,4,0,0,1,4,3.81l2.4,61.16a4,4,0,0,1-4,4.13h-32A4,4,0,0,1,227.89,406.25Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M264,378.73a4.89,4.89,0,0,1-.06-.74c0-.54-.06-1.25-.1-2.13-.06-1.91-.14-4.57-.24-7.83s-.18-7.25-.29-11.61q-.08-3.29-.15-6.86a11.31,11.31,0,0,0-.4-3.5,2.88,2.88,0,0,0-1-1.37,3.48,3.48,0,0,0-1.63-.59,32.42,32.42,0,0,0-3.69,0l-3.63.08-6.86.13-11.61.2-4.46.06a14.21,14.21,0,0,0-3.32.21A2.29,2.29,0,0,0,225,346a2.14,2.14,0,0,0-.12.71,1.13,1.13,0,0,1,0-.74,2.37,2.37,0,0,1,1.56-1.44,13.51,13.51,0,0,1,3.38-.31l4.46-.14,11.61-.31,6.86-.16,3.63-.09a34,34,0,0,1,3.77,0,4.13,4.13,0,0,1,1.87.69,3.35,3.35,0,0,1,1.15,1.61,11.71,11.71,0,0,1,.42,3.67q.06,3.57.12,6.86c.07,4.36.13,8.29.18,11.61s.06,5.93.08,7.83c0,.89,0,1.6,0,2.13A4,4,0,0,1,264,378.73Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M245.35,355a2.12,2.12,0,0,0-2.2-1.24,1.89,1.89,0,0,0-2.35,1.61,2.42,2.42,0,0,0,1.8,2.43,2.47,2.47,0,0,0,2.3-.54A2,2,0,0,0,245.35,355Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M208.68,394.29v-6.23s6.12-14.4,5.94-13.87,10.85-7.05,10.85-7.05a30.65,30.65,0,0,1-.36,9.51,16.24,16.24,0,0,1-3.64,6.32l-.86,6.72,13.86-11.29L251,369.71a5.69,5.69,0,0,1,5.09,2.37c2.11,2.81-.88,5.62-2.28,6.5s-14,10-14,10l-7,8.07,1.49,1.7,12.36-7.84s15.63-11.41,19.14-12.12l.19,0a3.26,3.26,0,0,1,3.1,5.22c-4.3,5.59-11.7,15.1-12.07,14.77-.53-.46-16.58,10.6-16.58,10.6s16.05-5.27,17.46-6.5,15.8-16.5,15.8-16.5,1.93.35,2.28,4.74l-.87,4.39s.35,1.05.87,3.33-7.55,17.92-7.55,17.92-31.61,17.38-34.59,17.56-14.05,0-14.05,0Z",
					style: { fill: "#b47266" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M274.77,394.54a5.43,5.43,0,0,1-.6,1.33,29.83,29.83,0,0,1-2.19,3.35c-1,1.37-2.24,2.93-3.5,4.76a37.25,37.25,0,0,1-4.73,5.53,49.16,49.16,0,0,1-10.9,7.41c-1.49.78-2.71,1.38-3.57,1.79a7.11,7.11,0,0,1-1.34.57,7.57,7.57,0,0,1,1.25-.75l3.49-1.93a54.31,54.31,0,0,0,10.71-7.47,38.37,38.37,0,0,0,4.7-5.43c1.28-1.82,2.57-3.37,3.59-4.7s1.81-2.44,2.31-3.23A12,12,0,0,1,274.77,394.54Z",
					style: { fill: "#89544c" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M160.37,409.19a29.94,29.94,0,0,0-5.82,3.61,31.58,31.58,0,0,0-9.2,13.52A67.88,67.88,0,0,0,142,442.55c-.2,2.06-.36,3.75-.48,5-.06.55-.1,1-.14,1.37a1.43,1.43,0,0,1-.09.47,2.49,2.49,0,0,1,0-.48c0-.37,0-.83.05-1.37,0-1.19.14-2.92.31-5.05a63,63,0,0,1,3.19-16.37,30.87,30.87,0,0,1,9.46-13.63,20.78,20.78,0,0,1,4.31-2.66c.54-.27,1-.4,1.28-.52A2.85,2.85,0,0,1,160.37,409.19Z",
					style: { fill: "#263238" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "freepik--Desk--inject-3",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M488.58,449.57c0,.14-104.22.26-232.75.26s-232.77-.12-232.77-.26,104.2-.26,232.77-.26S488.58,449.43,488.58,449.57Z",
				style: { fill: "#263238" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Device--inject-3",
			children: [
				/* @__PURE__ */ _jsx("polygon", {
					points: "376.45 451.17 240.75 452.09 327.77 470.85 359.45 462.95 376.45 451.17",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.75,457.52l87,21.62,133.79-10.31L488,362.51c1.92-6.41-1.32-9.92-5.41-9.9l-124.82,6.18a8.74,8.74,0,0,0-8.07,6.95L327.77,470.85l-87-18.76Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.75,457.52s0-.43,0-1.33,0-2.27,0-4.1v0h.06l87.05,18.62-.22.14,10.41-50,5.87-28.16q1.51-7.29,3.08-14.79.78-3.75,1.57-7.56c.27-1.27.53-2.54.8-3.82a9.9,9.9,0,0,1,1.37-3.74,8.94,8.94,0,0,1,6.71-4.13c2.67-.17,5.34-.28,8-.42l16.35-.81,33.8-1.69,35.09-1.74,18-.89,9.08-.45,4.56-.23a6.3,6.3,0,0,1,4.43,1.44,6.22,6.22,0,0,1,2,3.5,10.24,10.24,0,0,1-.1,4q-.94,3.8-1.88,7.57-1.87,7.51-3.72,15-3.71,14.87-7.3,29.32c-4.8,19.26-9.44,37.9-13.88,55.76l0,.17h-.18l-133.8,10.24h0l-63.94-16L246.65,459l-4.42-1.12c-1-.25-1.48-.39-1.48-.39l1.52.36,4.46,1.09,17.19,4.22L327.81,479h-.05l133.78-10.37-.22.18c4.44-17.86,9.08-36.51,13.86-55.77q3.6-14.44,7.29-29.33,1.86-7.43,3.73-15c.62-2.5,1.24-5,1.87-7.53a9.83,9.83,0,0,0,.1-3.78,5.76,5.76,0,0,0-1.79-3.21c-2.3-2.07-5.67-1.05-8.64-1.08l-9.08.45-18,.89-35.09,1.73-33.8,1.67-16.35.81c-2.69.14-5.38.24-8,.41a8.51,8.51,0,0,0-6.35,3.9,9.75,9.75,0,0,0-1.31,3.59c-.26,1.27-.53,2.55-.79,3.81-.54,2.54-1.06,5.06-1.59,7.56q-1.56,7.51-3.09,14.79-3,14.55-5.89,28.16c-3.8,18.11-7.31,34.87-10.48,50l0,.17-.18,0-87-18.88,0-.05c0,1.82,0,3.18,0,4.08S240.75,457.52,240.75,457.52Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M412.67,406a7.56,7.56,0,0,0-5.89,4.71,5.71,5.71,0,0,0,2.51,6.81c2.78,1.41,6.38-.24,8-2.91a7.16,7.16,0,0,0,.64-5.71c-.58-2-4-3.31-5.26-2.9",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M412.67,406a2.22,2.22,0,0,1,1.48-.06,6.7,6.7,0,0,1,1.65.58,5,5,0,0,1,1.84,1.44,3.08,3.08,0,0,1,.58,1.27,7.44,7.44,0,0,1,.23,1.45,7.27,7.27,0,0,1-.52,3.22,7.47,7.47,0,0,1-5.76,4.35,5.11,5.11,0,0,1-3.74-1,5.68,5.68,0,0,1-2-3,6.21,6.21,0,0,1,0-3.26,6.6,6.6,0,0,1,1.37-2.48,7.86,7.86,0,0,1,3.38-2.21,7.17,7.17,0,0,1,1.07-.27c.25,0,.38,0,.38,0s-.51.13-1.38.48a8.1,8.1,0,0,0-3.17,2.26,6.24,6.24,0,0,0-1.23,2.36,5.74,5.74,0,0,0,0,3,5.21,5.21,0,0,0,1.81,2.74,4.61,4.61,0,0,0,3.37.88,7.08,7.08,0,0,0,5.38-4,6.84,6.84,0,0,0,.53-3,4.92,4.92,0,0,0-.67-2.53,5,5,0,0,0-1.68-1.41,7.43,7.43,0,0,0-1.57-.63A4.08,4.08,0,0,0,412.67,406Z",
					style: { fill: "#263238" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Reminder--inject-3",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M148.49,213.71H79.72A6.29,6.29,0,0,0,73.43,220v68.77a6.29,6.29,0,0,0,6.29,6.29H127.3l19.14,15.76V295.06h2.05a6.29,6.29,0,0,0,6.29-6.29V220A6.29,6.29,0,0,0,148.49,213.71Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80.48,213.71h68.3a6,6,0,0,1,6,6v19.45a.23.23,0,0,1-.23.23H73.66a.23.23,0,0,1-.23-.23V220.75A7,7,0,0,1,80.48,213.71Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M108.52,251.52v27.65h-6.4V256.65H96.59v-5.13Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M135,251.52v4.14l-10.27,23.51h-7l9.92-22.44h-9.17v4.5h-5.69v-9.71Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M125.47,228.28c0,.15-5.59.26-12.48.26s-12.49-.11-12.49-.26S106.09,228,113,228,125.47,228.14,125.47,228.28Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.49,213.71h.43a5.74,5.74,0,0,1,1.24.19,6.31,6.31,0,0,1,3.83,2.9,6.45,6.45,0,0,1,.88,3.46c0,1.32,0,2.75,0,4.29,0,3.1,0,6.65,0,10.63,0,7.95,0,17.59.05,28.6,0,5.51,0,11.37,0,17.54,0,1.54,0,3.1,0,4.68v2.38a7.36,7.36,0,0,1-.33,2.45,6.48,6.48,0,0,1-5.7,4.43c-.87.05-1.68,0-2.53,0l.23-.23c0,5,0,10.29,0,15.76v.51l-.4-.33-19.14-15.74.16.05H79.64a6.68,6.68,0,0,1-2.17-.41,6.47,6.47,0,0,1-3.35-2.76,6.55,6.55,0,0,1-.81-2,10.5,10.5,0,0,1-.14-2.15V275.5c0-10.94,0-21.49,0-31.54,0-5,0-9.93,0-14.69q0-3.57,0-7a23.78,23.78,0,0,1,.12-3.47,6.55,6.55,0,0,1,4.38-5,9.83,9.83,0,0,1,3.3-.32h6.35l11.93,0,36,.08,9.79,0,2.54,0c.58,0,.87,0,.87,0l-.87,0-2.54,0-9.79.05-36,.09H81a9.5,9.5,0,0,0-3.16.3A6.2,6.2,0,0,0,75.19,216a6.12,6.12,0,0,0-1.43,2.89,23.65,23.65,0,0,0-.1,3.39v7c0,4.76,0,9.67,0,14.69,0,10,0,20.6,0,31.54V288a9.91,9.91,0,0,0,.13,2.05,6,6,0,0,0,3.83,4.41,11.53,11.53,0,0,0,4.14.38h45.6l.07.05,19.13,15.77-.4.19c0-5.47,0-10.79,0-15.76v-.23h.24c.83,0,1.69,0,2.5,0a6.08,6.08,0,0,0,2.29-.64,6,6,0,0,0,3-3.48,6.66,6.66,0,0,0,.32-2.31V286c0-1.58,0-3.14,0-4.68,0-6.17,0-12,0-17.54,0-11,0-20.65,0-28.6,0-4,0-7.53,0-10.63s.4-5.83-.82-7.67a6.18,6.18,0,0,0-3.72-2.9A9.58,9.58,0,0,0,148.49,213.71Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 123.51,
					y: 205.74,
					width: 5.29,
					height: 18.37,
					rx: 2.56,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M126.25,224.11a3.25,3.25,0,0,0,1.5-.62,2.42,2.42,0,0,0,.88-1.61c0-.73,0-1.64,0-2.6,0-2,0-4.27-.05-6.82,0-1.29,0-2.64,0-4a2.32,2.32,0,0,0-2.48-2.43,2.33,2.33,0,0,0-1.74.79,2.45,2.45,0,0,0-.56,1.81c0,1.4,0,2.75,0,4,0,2.55,0,4.86,0,6.83,0,.48,0,.94,0,1.38a6.73,6.73,0,0,0,0,1.21,2.49,2.49,0,0,0,1,1.54,3.31,3.31,0,0,0,1.55.52,1.09,1.09,0,0,1-.44,0,2.48,2.48,0,0,1-1.22-.39,2.71,2.71,0,0,1-1.17-1.65,6.63,6.63,0,0,1-.07-1.27c0-.44,0-.9,0-1.38,0-2,0-4.28-.06-6.83,0-1.28,0-2.63,0-4a2.91,2.91,0,0,1,.68-2.15,2.81,2.81,0,0,1,2.13-1,2.82,2.82,0,0,1,3,3c0,1.39,0,2.74,0,4,0,2.55,0,4.85-.06,6.82,0,1,0,1.83-.07,2.64a2.57,2.57,0,0,1-1,1.73,2.37,2.37,0,0,1-1.18.47A.88.88,0,0,1,126.25,224.11Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 98.68,
					y: 205.74,
					width: 5.29,
					height: 18.37,
					rx: 2.56,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M101.41,224.11a3.23,3.23,0,0,0,1.51-.62,2.42,2.42,0,0,0,.88-1.61c0-.73,0-1.64,0-2.6,0-2,0-4.27-.06-6.82,0-1.29,0-2.64,0-4a2.32,2.32,0,0,0-2.48-2.43,2.32,2.32,0,0,0-1.74.79,2.45,2.45,0,0,0-.57,1.81c0,1.4,0,2.75,0,4,0,2.55,0,4.86-.06,6.83,0,.48,0,.94,0,1.38a6.66,6.66,0,0,0,0,1.21,2.45,2.45,0,0,0,1,1.54,3.26,3.26,0,0,0,1.54.52s-.14,0-.44,0a2.45,2.45,0,0,1-1.21-.39,2.67,2.67,0,0,1-1.17-1.65,7.53,7.53,0,0,1-.08-1.27c0-.44,0-.9,0-1.38,0-2,0-4.28,0-6.83,0-1.28,0-2.63,0-4a3,3,0,0,1,.69-2.15,2.8,2.8,0,0,1,2.13-1,2.83,2.83,0,0,1,3,3c0,1.39,0,2.74,0,4,0,2.55,0,4.85,0,6.82,0,1,0,1.83-.07,2.64a2.64,2.64,0,0,1-1,1.73,2.41,2.41,0,0,1-1.18.47A.91.91,0,0,1,101.41,224.11Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .30000000000000004 },
					children: /* @__PURE__ */ _jsx("path", { d: "M95.65,214.48a24.92,24.92,0,0,1-22.27,27.33l1-13.67,12.39-13.47Z" })
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 68.15,
					cy: 213.52,
					r: 23.32,
					transform: "translate(-50.12 23.13) rotate(-14.15)",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.13,239.35a25.83,25.83,0,1,1,25.59-29.46h0A25.87,25.87,0,0,1,71.78,239.1,26.66,26.66,0,0,1,68.13,239.35Zm.06-46.63a21.19,21.19,0,0,0-3,.21A20.8,20.8,0,1,0,88.74,210.6h0a20.8,20.8,0,0,0-20.55-17.88Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.13,239.35a25.83,25.83,0,1,1,25.59-29.46h0A25.87,25.87,0,0,1,71.78,239.1,26.66,26.66,0,0,1,68.13,239.35Zm.06-46.63a21.19,21.19,0,0,0-3,.21A20.8,20.8,0,1,0,88.74,210.6h0a20.8,20.8,0,0,0-20.55-17.88Z",
					style: { fill: "none" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.19,192.72a1.23,1.23,0,0,1,.34,0c.22,0,.55,0,1,0a19.16,19.16,0,0,1,3.78.55,20.63,20.63,0,0,1,5.59,2.28,21.09,21.09,0,0,1,6,5.3,20.77,20.77,0,0,1,3.93,8.84,25.24,25.24,0,0,1,.32,2.65,12.48,12.48,0,0,1,0,1.37c0,.46,0,.93,0,1.4a22.77,22.77,0,0,1-1.2,5.63A23.16,23.16,0,0,1,85,226.06a22.71,22.71,0,0,1-4.47,4.45,21.07,21.07,0,0,1-24.91,0,20.93,20.93,0,0,1-7.31-9.81A22.8,22.8,0,0,1,47.17,215a21.08,21.08,0,0,1,.32-5.42,20.82,20.82,0,0,1,15.59-16.35c.81-.18,1.54-.31,2.17-.39l1.61-.09,1,0h.34l-.34.05-1,.09-1.6.14c-.63.1-1.34.24-2.14.44a21.24,21.24,0,0,0-5.51,2.3A21,21,0,0,0,51.77,201a20.57,20.57,0,0,0-3.85,8.67,20.27,20.27,0,0,0-.29,5.31,22.08,22.08,0,0,0,1.17,5.5,22.5,22.5,0,0,0,2.79,5.22A22.8,22.8,0,0,0,56,230.05a20.6,20.6,0,0,0,24.3,0,20.57,20.57,0,0,0,7.19-9.54,21.62,21.62,0,0,0,1.2-5.5c.06-.45,0-.91,0-1.36a12,12,0,0,0,0-1.34c-.09-.88-.13-1.76-.3-2.61a20.58,20.58,0,0,0-3.8-8.69,21,21,0,0,0-11.33-7.61,21,21,0,0,0-3.74-.63C68.65,192.74,68.19,192.75,68.19,192.72Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.13,239.35l.42,0,1.22-.07c.54,0,1.2-.11,2-.23l2.67-.55a28,28,0,0,0,6.84-2.87,26.43,26.43,0,0,0,7.27-6.55,25.91,25.91,0,0,0,4.77-10.8,12.1,12.1,0,0,0,.24-1.6c0-.54.12-1.08.17-1.63s0-1.11,0-1.67v-.85l-.08-.85a24.87,24.87,0,0,0-1.44-6.85,25.68,25.68,0,0,0-24-16.85,25.56,25.56,0,0,0-24.08,16.82A25.27,25.27,0,0,0,43,218.22a25.55,25.55,0,0,0,1.83,5.9,27.31,27.31,0,0,0,1.36,2.58l.74,1.21.83,1.11A25.59,25.59,0,0,0,55,235.58a26.74,26.74,0,0,0,6.84,2.87,20.93,20.93,0,0,0,2.66.54,16.24,16.24,0,0,0,2,.24l1.23.08.42,0a1.67,1.67,0,0,1-.42,0l-1.23,0a15.15,15.15,0,0,1-2-.18,19.36,19.36,0,0,1-2.68-.51,25.56,25.56,0,0,1-14.35-9.4l-.84-1.12-.76-1.22a28.07,28.07,0,0,1-1.4-2.61,26.36,26.36,0,0,1-1.88-6,25.73,25.73,0,0,1,1.06-13.69,26,26,0,0,1,24.53-17.18,26.07,26.07,0,0,1,24.5,17.21,25.12,25.12,0,0,1,1.45,7l.07.86v.86c0,.57,0,1.14,0,1.7s-.12,1.12-.18,1.67a10.92,10.92,0,0,1-.25,1.62,26.27,26.27,0,0,1-4.9,10.95,26.6,26.6,0,0,1-7.41,6.57,27.86,27.86,0,0,1-6.94,2.82l-2.7.51c-.78.1-1.45.15-2,.17s-1,0-1.23,0S68.13,239.35,68.13,239.35Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 83.75,
					y: 179.41,
					width: 4.02,
					height: 16.12,
					transform: "matrix(0.53, -0.85, 0.85, 0.53, -118.66, 160.82)",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M91.53,193.45a9.57,9.57,0,0,1,.53-1L93.53,190l0,.22c-3.1-1.87-8.11-4.95-13.72-8.46l.36-.08h0v0l0,0,0,.06-.07.11-.14.21-.27.44-.54.86q-.52.85-1,1.68l-.08-.35c3.85,2.42,7.2,4.57,9.62,6.15l2.86,1.87a11.81,11.81,0,0,1,1,.74,8.13,8.13,0,0,1-1-.56l-2.89-1.72c-2.46-1.48-5.94-3.59-9.89-6l-.22-.14.14-.21,1-1.69.54-.86.27-.43.14-.22.07-.11,0-.05,0,0h0l.35-.08c5.62,3.51,10.58,6.66,13.62,8.63l.13.09-.08.13c-.72,1.1-1.29,1.94-1.67,2.51A6.06,6.06,0,0,1,91.53,193.45Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 34.47,
					y: 192.68,
					width: 16.97,
					height: 4.02,
					transform: "translate(-131.65 98.44) rotate(-48.69)",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.87,202.39s.3-.4.84-1.06L42,198.58c2-2.31,4.7-5.5,7.84-9.1l0,.36-3-2.65.37,0h0l0,0-.06.07-.11.12-.21.24-.43.49-.85,1L43.89,191l-3.07,3.46L36,199.84v-.22c.87.81,1.58,1.48,2.14,2s.78.76.78.78a5.17,5.17,0,0,1-.81-.61c-.53-.43-1.32-1.08-2.31-1.93l-.12-.1.1-.11,4.74-5.52,3-3.48c.53-.62,1.08-1.24,1.64-1.88.27-.32.56-.64.84-1l.43-.49.21-.24.11-.13.06-.06,0,0,0,0h0l.37,0,3,2.66.19.17-.17.19c-3.24,3.66-6.1,6.84-8.14,9.08l-2.39,2.61A9.35,9.35,0,0,1,38.87,202.39Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "57.98 215.56 59.97 211.78 67.08 214.99 74.73 201.06 78.31 203.12 68.4 220.69 57.98 215.56",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.41,220.72h0L58,215.57v0l2-3.81h0L67.07,215,74.72,201h0l3.6,2.07v0ZM58,215.55l10.38,5.1,9.89-17.52-3.54-2L67.09,215h0L60,211.81Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M54.26,242.31a5.07,5.07,0,0,1-1.09-.46A10.85,10.85,0,0,1,52,241.2a17.55,17.55,0,0,1-1.56-1,27.38,27.38,0,0,1-3.73-3,31.55,31.55,0,0,1-3.82-4.44,31.93,31.93,0,0,1-2.87-5.1,28.79,28.79,0,0,1-1.53-4.53,17.55,17.55,0,0,1-.37-1.8,10.57,10.57,0,0,1-.19-1.37,5.73,5.73,0,0,1-.06-1.17c.1,0,.26,1.66,1,4.25a31.32,31.32,0,0,0,1.61,4.42,33.55,33.55,0,0,0,2.86,5A34,34,0,0,0,47,236.91a31.19,31.19,0,0,0,3.61,3C52.79,241.5,54.31,242.22,54.26,242.31Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.46,237a9.79,9.79,0,0,1-1.67-1.92,34,34,0,0,1-3.17-5.28A32.51,32.51,0,0,1,35.49,224,9.27,9.27,0,0,1,35,221.5a20.64,20.64,0,0,1,.81,2.4,45.58,45.58,0,0,0,2.24,5.66,47.12,47.12,0,0,0,3,5.28A17.81,17.81,0,0,1,42.46,237Z",
					style: { fill: "#263238" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--speech-bubble--inject-3",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M350.16,220.85,361.41,201a53.1,53.1,0,1,1,12.72,14.16l0,0Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M350.16,220.85l24-5.77-.07.2,0,0a.12.12,0,0,1,0-.18.12.12,0,0,1,.16,0,54.32,54.32,0,0,0,10.88,6.48,52.83,52.83,0,0,0,14.45,4.07,48.64,48.64,0,0,0,8.34.4c1.43-.09,2.89-.13,4.36-.26l4.44-.68A53.14,53.14,0,0,0,449.48,204a52.42,52.42,0,0,0,8.86-20.29,53.64,53.64,0,0,0-.64-23.35c-.26-1-.48-2-.77-2.92l-1-2.85a49.55,49.55,0,0,0-2.48-5.59,25.14,25.14,0,0,0-1.52-2.67c-.54-.88-1.06-1.77-1.62-2.64l-1.86-2.49-.93-1.25c-.31-.42-.69-.78-1-1.17l-2.14-2.36c-.71-.79-1.55-1.44-2.31-2.17l-1.17-1.06a11.66,11.66,0,0,0-1.21-1l-2.52-1.88c-.42-.3-.82-.65-1.27-.91l-1.34-.82-2.66-1.61-2.78-1.36a25.21,25.21,0,0,0-2.82-1.25,53.53,53.53,0,0,0-23.52-3.63A51.73,51.73,0,0,0,381.1,127a53.4,53.4,0,0,0-25,30.65,57.14,57.14,0,0,0-2.34,17.11,52.55,52.55,0,0,0,2.52,14.8A54,54,0,0,0,361.51,201a.11.11,0,0,1,0,.13l-11.35,19.76c.43-.78,4-7.11,11.14-19.89v.13A54.3,54.3,0,0,1,356,189.68a52.38,52.38,0,0,1-2.59-14.89,57.3,57.3,0,0,1,2.31-17.24,53.84,53.84,0,0,1,25.16-31,52.42,52.42,0,0,1,21.8-6.44,54.16,54.16,0,0,1,23.76,3.65,25.65,25.65,0,0,1,2.84,1.27c.93.45,1.88.89,2.81,1.36l2.69,1.63,1.35.82c.45.27.85.62,1.28.93l2.55,1.9a11.77,11.77,0,0,1,1.22,1l1.18,1.07c.77.74,1.62,1.4,2.33,2.2l2.16,2.38c.35.4.73.76,1,1.18l.94,1.26,1.88,2.52c.57.87,1.09,1.77,1.64,2.66a26.7,26.7,0,0,1,1.53,2.7,48.66,48.66,0,0,1,2.5,5.64q.53,1.46,1.05,2.88c.29,1,.52,2,.78,3a54,54,0,0,1,.63,23.57,52.92,52.92,0,0,1-9,20.48,53.38,53.38,0,0,1-33.11,21.26l-4.48.68c-1.48.13-2.95.16-4.39.24a46.42,46.42,0,0,1-8.4-.42A52.87,52.87,0,0,1,385,221.85a54.43,54.43,0,0,1-10.91-6.57l.18-.18,0,0a.14.14,0,0,1,0,.19l-.05,0Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M412.59,148.85l-1.77,28a4.55,4.55,0,0,1-4.27,4.25h0a4.53,4.53,0,0,1-4.78-4l-3.11-28.14a3.57,3.57,0,0,1,3.59-4l6.83.1A3.57,3.57,0,0,1,412.59,148.85Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M400.6,196.85a6.84,6.84,0,1,0,4.34-8.64A6.85,6.85,0,0,0,400.6,196.85Z",
					style: { fill: "#8A6BD6" }
				})
			]
		})
	]
});
export default SvgNoReminders;
